/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileType } from './FileType';
import {
    FileTypeFromJSON,
    FileTypeFromJSONTyped,
    FileTypeToJSON,
    FileTypeToJSONTyped,
} from './FileType';
import type { MediaGroup } from './MediaGroup';
import {
    MediaGroupFromJSON,
    MediaGroupFromJSONTyped,
    MediaGroupToJSON,
    MediaGroupToJSONTyped,
} from './MediaGroup';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface GetMediaResponse
 */
export interface GetMediaResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetMediaResponse
     */
    mediaId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof GetMediaResponse
     */
    url: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMediaResponse
     */
    externalUrl: string | null;
    /**
     * 
     * @type {FileType}
     * @memberof GetMediaResponse
     */
    fileType: FileType;
    /**
     * 
     * @type {MediaGroup}
     * @memberof GetMediaResponse
     */
    mediaGroup: MediaGroup;
    /**
     * 
     * @type {string}
     * @memberof GetMediaResponse
     */
    fileName: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMediaResponse
     */
    mediaKey: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMediaResponse
     */
    contentType: string | null;
}



/**
 * Check if a given object implements the GetMediaResponse interface.
 */
export function instanceOfGetMediaResponse(value: object): value is GetMediaResponse {
    if (!('mediaId' in value) || value['mediaId'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('externalUrl' in value) || value['externalUrl'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('mediaGroup' in value) || value['mediaGroup'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('mediaKey' in value) || value['mediaKey'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    return true;
}

export function GetMediaResponseFromJSON(json: any): GetMediaResponse {
    return GetMediaResponseFromJSONTyped(json, false);
}

export function GetMediaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMediaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'mediaId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['mediaId']),
        'url': json['url'],
        'externalUrl': json['externalUrl'],
        'fileType': FileTypeFromJSON(json['fileType']),
        'mediaGroup': MediaGroupFromJSON(json['mediaGroup']),
        'fileName': json['fileName'],
        'mediaKey': json['mediaKey'],
        'contentType': json['contentType'],
    };
}

export function GetMediaResponseToJSON(json: any): GetMediaResponse {
    return GetMediaResponseToJSONTyped(json, false);
}

export function GetMediaResponseToJSONTyped(value?: GetMediaResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mediaId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['mediaId']),
        'url': value['url'],
        'externalUrl': value['externalUrl'],
        'fileType': FileTypeToJSON(value['fileType']),
        'mediaGroup': MediaGroupToJSON(value['mediaGroup']),
        'fileName': value['fileName'],
        'mediaKey': value['mediaKey'],
        'contentType': value['contentType'],
    };
}

